"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PriceFormatter = function PriceFormatter(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value;
  return _react["default"].createElement("div", null, _react["default"].createElement("span", null, new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  }).format(value)));
};

PriceFormatter.propTypes = {
  value: _propTypes["default"].number
};
PriceFormatter.defaultProps = {
  value: 0
};
var _default = PriceFormatter;
exports["default"] = _default;